import React, { useState } from 'react';
import { StaticPage, TopbarContainer } from '..';
import {
  Footer,
  Form,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  PrimaryButton,
} from '../../components';
import { Form as FinalForm } from 'react-final-form';
import FieldInput from './FieldInput';
import { composeValidators, emailFormatValid, required } from '../../util/validators';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import css from './ContactUsPage.module.css';
function ContactUsPage() {
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const history = useHistory();

  const handleSubmit = async formValues => {
    const { name, phone, email, subject, message } = formValues;
    // const name = `${firstName} ${lastName}`;
    setSubmitting(true);
    setErrorMessage(null);

    try {
      const response = await axios.post('/contact', { name, phone, email, subject, message });
      const { success } = response.data;

      if (success)
        history.push({
          pathname: '/success',
          params: {
            success,
          },
        });
    } catch (e) {
      const error = e.response?.data?.message || e.message;
      setErrorMessage(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <StaticPage
      title="Contact Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactUsPage',
        description: 'Contact Cupradar',
        name: 'Contact page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <FinalForm
            onSubmit={handleSubmit}
            submitInProgress={submitting}
            errorMessage={errorMessage}
            render={fieldRenderProps => {
              const {
                values,
                errors,
                handleSubmit,
                submitInProgress,
                errorMessage,
              } = fieldRenderProps;

              const submitDisabled = !(
                values?.name &&
                values?.email &&
                values?.subject &&
                values?.phone &&
                values?.message &&
                Object.keys(errors || {}).length == 0
              );

              return (
                <>
                  <div className="bg-white">
                    <div className="mx-auto max-w-3xl w-full my-2 sm:my-4 md:my-8 p-8">
                      <h1
                        className={css.title}
                        // className="text-3xl m-0 mb-6 font-extrabold tracking-normal sm:text-4xl text-center text-gray-500 uppercase "
                        style={{ color: 'var(--matterColor)' }}
                      >
                        Contact Us
                      </h1>
                      <h2 className={css.subTitle}>Get In Touch With Us</h2>
                      <p className={css.subHeading}>We Are Always Here To Help.</p>
                      <Form onSubmit={handleSubmit}>
                        <div className={css.main}>
                          {/* <div className="grid grid-cols-2 gap-x-6 gap-y-2"> */}
                          <div>
                            <FieldInput
                              type="text"
                              name="name"
                              id="name"
                              placeholder="Your Name"
                              validate={required('Name is Required')}
                            />
                          </div>
                          <div>
                            <FieldInput
                              type="email"
                              name="email"
                              id="email"
                              placeholder="Email Address"
                              validate={composeValidators(
                                required('Email is required'),
                                emailFormatValid('Please enter a valid email')
                              )}
                            />
                          </div>
                          <div>
                            <FieldInput
                              type="number"
                              name="phone"
                              id="phone"
                              placeholder="Phone Number"
                              validate={required('Phone Number is required')}
                            />
                          </div>

                          <div>
                            <FieldInput
                              type="text"
                              name="subject"
                              id="subject"
                              placeholder="Subject"
                              validate={required('Subject is required')}
                            />
                          </div>
                          <div className="col-span-2">
                            {/* <FieldInput
                              type="email"
                              name="email"
                              id="email"
                              label="Email"
                              placeholder="Email"
                              validate={composeValidators(
                                required('This field is required'),
                                emailFormatValid('Please enter a valid email')
                              )}
                            /> */}
                          </div>
                          <div className="col-span-2">
                            {/* <FieldInput
                              type="text"
                              name="subject"
                              id="subject"
                              label="Subject"
                              placeholder="Subject"
                              validate={required('This field is required')}
                            /> */}
                          </div>
                          <div className="col-span-2 group">
                            <FieldInput
                              type="textarea"
                              name="message"
                              id="message"
                              label="Message"
                              placeholder="Message"
                              validate={required('Message is required')}
                            />
                          </div>
                          {errorMessage && (
                            <h3 className="text-red-500 text-lg font-sans font-semibold m-0 mt-2 col-span-2">
                              Failed to send the message. Please try again later...
                            </h3>
                          )}
                          <div className="col-span-2">
                            <PrimaryButton
                              disabled={submitDisabled || submitInProgress}
                              className={css.submit}
                            >
                              Send Message
                            </PrimaryButton>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </>
              );
            }}
          />
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
}

export default ContactUsPage;
